import React from "react"
import {formatTextTestIds} from "@next/utils"
import {PriceLabel, PriceValue, PriceRowContainer, Container, WasPriceValue, SalePriceValue} from "../../components"

export const SuitPrice = ({
    tooltipTitle,
    trouserPrice,
    saleTrouserPrice,
    suitPrice,
    saleSuitPrice,
    jacketPrice,
    saleJacketPrice,
    text,
    jacketsHasSale,
    trousersHasSale,
    suitPriceAriaLabel,
    suitJacketPriceAriaLabel,
    suitTrousersPriceAriaLabel,
    wasSuitPriceText,
    saleSuitPriceText,
    wasTrouserPriceText,
    saleTrouserPriceText,
    wasJacketPriceText,
    saleJacketPriceText,
    suitsHasSale,
    brandedMarkdownSalePrice,
}) => {
    return (
        <Container>
            <PriceRowContainer
                title={tooltipTitle}
                variant="h5"
                data-testid={formatTextTestIds("suit_summary_suit_price")}
                aria-label={suitPriceAriaLabel}
            >
                <PriceLabel isSalePrice={saleSuitPrice as boolean}>{text.labels.suitPrice}</PriceLabel>
                {saleSuitPrice ? (
                    <>
                        <WasPriceValue data-testid={formatTextTestIds("was_suit_price")}>
                            {wasSuitPriceText}
                        </WasPriceValue>
                        <SalePriceValue
                            data-testid={formatTextTestIds("sale_suit_price")}
                            $brandedMarkdownSalePrice={brandedMarkdownSalePrice}
                        >
                            {saleSuitPriceText}
                        </SalePriceValue>
                    </>
                ) : (
                    <PriceValue data-testid={formatTextTestIds("suit_price")}>{suitPrice}</PriceValue>
                )}
            </PriceRowContainer>
            {suitsHasSale && !saleSuitPrice && (
                <SalePriceValue
                    data-testid={formatTextTestIds("suit_summary_suit_placeholder")}
                    $brandedMarkdownSalePrice={brandedMarkdownSalePrice}
                />
            )}

            <PriceRowContainer
                title={tooltipTitle}
                variant="h5"
                data-testid={formatTextTestIds("suit_summary_jacket_price")}
                aria-label={suitJacketPriceAriaLabel}
            >
                <PriceLabel>{text.labels.jacket}</PriceLabel>
                {saleJacketPrice ? (
                    <>
                        <WasPriceValue data-testid={formatTextTestIds("was_jacket_price")}>
                            {wasJacketPriceText}
                        </WasPriceValue>
                        <SalePriceValue
                            data-testid={formatTextTestIds("sale_jacket_price")}
                            $brandedMarkdownSalePrice={brandedMarkdownSalePrice}
                        >
                            {saleJacketPriceText}
                        </SalePriceValue>
                    </>
                ) : (
                    <PriceValue data-testid={formatTextTestIds("jacket_price")}>{jacketPrice}</PriceValue>
                )}
            </PriceRowContainer>
            {jacketsHasSale && !saleJacketPrice && (
                <SalePriceValue $brandedMarkdownSalePrice={brandedMarkdownSalePrice} />
            )}

            <PriceRowContainer
                title={tooltipTitle}
                variant="h5"
                data-testid={formatTextTestIds("suit_summary_trouser_price")}
                aria-label={suitTrousersPriceAriaLabel}
            >
                <PriceLabel>{text.labels.trousers}</PriceLabel>
                {saleTrouserPrice ? (
                    <>
                        <WasPriceValue data-testid={formatTextTestIds("was_trouser_price")}>
                            {wasTrouserPriceText}
                        </WasPriceValue>
                        <SalePriceValue
                            data-testid={formatTextTestIds("sale_trouser_price")}
                            $brandedMarkdownSalePrice={brandedMarkdownSalePrice}
                        >
                            {saleTrouserPriceText}
                        </SalePriceValue>
                    </>
                ) : (
                    <PriceValue data-testid={formatTextTestIds("trouser_price")}>{trouserPrice}</PriceValue>
                )}
            </PriceRowContainer>
            {trousersHasSale && !saleTrouserPrice && (
                <SalePriceValue $brandedMarkdownSalePrice={brandedMarkdownSalePrice} />
            )}
        </Container>
    )
}

export default SuitPrice
